import React, { useEffect, useState } from "react";
import "./styles.css";

function TooltipButton({
  isTooltipVisible = false,
  buttonTitle,
  message,
  srcImg,
  onClick,
  isDisabled = false,
}) {
  const [showTooltip, setShowTooltip] = useState(isTooltipVisible || false);

  useEffect(() => {
    setShowTooltip(isTooltipVisible);
  }, [isTooltipVisible]);

  const disabledStyle = isDisabled
    ? {
        background: "#ffffff",
        color: "rgba(16, 16, 16, 0.22)",
        borderColor: "rgba(16, 16, 16, 0.13)",
        cursor: "unset",
        opacity: 0.5,
      }
    : {};

  return (
    <div className="tooltip-container">
      <button
        className="tooltip-button"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={onClick}
        style={disabledStyle}
      >
        <span className="button-text">{buttonTitle}</span>
        <img src={srcImg} alt="" className="icon" />
      </button>

      {showTooltip && (
        <div className={`tooltip ${buttonTitle === "Email" ? "emailTooltip" : ""}`}>{message}</div>
      )}
    </div>
  );
}

export default TooltipButton;